import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { formatTranscriptTime, TranscriptUtterance } from '../../../_helpers/transcription';
import { ScrollToBottomDirective } from '../../directives/scroll-to-bottom.directive';

@Component({
  selector: 'app-transcript-list',
  standalone: true,
  imports: [CommonModule, TranslateModule, ScrollToBottomDirective],
  templateUrl: './transcript-list.component.html',
  styleUrl: './transcript-list.component.scss',
})
export class TranscriptListComponent {
  @Input() utterances: TranscriptUtterance[] = [];
  @Input() variant: 'dark' | 'light' = 'dark';
  @Input() deleted = false;

  readonly formatTime = formatTranscriptTime;
}
